//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateIdentificadores } from "@/typings/store/plugins/easyFirestore/identificadores";

const getters: GetterTree<StateIdentificadores, State> = {
  get(state) {
    return state.all;
  },
  getArray(state) {
    return Object.values(state.all);
  },
};

const rfids = {
  firestorePath: "{env}/v1/empresas/{idEmpresa}/identificadores",
  firestoreRefType: "collection",
  moduleName: "identificadores",
  statePropName: "all",
  namespaced: true,

  state: {},
  getters,
  mutations: {},
  actions: {},
};

export default rfids;
